import type { Phrases } from '../Phrases.d';

import React from 'react';
import { useWatch } from 'react-hook-form';
import { useFormContext } from '../../../../components/react-hook-form/FormContext';
import { Span } from '../../../../components/Element';
import { TextField } from '/react4xp/components/react-hook-form/TextField';
import {
	type ColorName,
	COLOR_NAME,
	COMMON_FIELD_NAME,
} from '../constants';


export const ColorOtherTextField = ({
	colorLabel,
	phrases,
}: {
	colorLabel: string;
	phrases: Phrases;
}): React.JSX.Element => {
	const {
		control,
	} =	useFormContext();
	const colors: ColorName[] = useWatch({ control, name: COMMON_FIELD_NAME.COLOR}) as ColorName[];
	const otherSelected = colors?.includes(COLOR_NAME.OTHER);
	const label = phrases['notificationForm.common.colorOtherField.label'];
	return (
		<TextField
			errorSummaryLabel={`${colorLabel} - ${label}`}
			fullWidth
			label={<Span textSize='lg'>{label}</Span>}
			name={COMMON_FIELD_NAME.COLOR_OTHER}
			showIf={({ watch }) => otherSelected}
		/>
	);
};
